/**
 * RNC: predictive search dropdown ordering.
 * Collections -> Products -> Suggestions -> other types -> Pages.
 * Moves existing category groups only; does not change search query/results.
 */
(function () {
  'use strict';
  if (window.__rncSearchGroupOrder) return;
  window.__rncSearchGroupOrder = true;

  function typeRank(group) {
    var heading = group.querySelector('h2, h3, h4, h5');
    var label = ((heading && heading.textContent) || group.getAttribute('data-type') || group.className || '').trim().toLowerCase();
    if (/\bcollections?\b/.test(label)) return 0;
    if (/\bproducts?\b/.test(label)) return 1;
    if (/\bsuggestions?\b|\bqueries?\b/.test(label)) return 2;
    if (/\bpages?\b/.test(label)) return 4;
    return 3;
  }

  function orderPanel(panel) {
    var groups = Array.prototype.slice.call(panel.querySelectorAll('.predictive-search-group, .search--result-group'))
      .filter(function (el) {
        return el.parentElement &&
          !el.parentElement.closest('.predictive-search-group, .search--result-group');
      });
    var byParent = new Map();
    groups.forEach(function (group) {
      var parent = group.parentNode;
      if (!byParent.has(parent)) byParent.set(parent, []);
      byParent.get(parent).push(group);
    });
    byParent.forEach(function (items, parent) {
      if (items.length < 2) return;
      var sorted = items.slice().sort(function (a, b) { return typeRank(a) - typeRank(b); });
      if (items.every(function (item, i) { return item === sorted[i]; })) return;
      var marker = document.createComment('rnc-search-order');
      parent.insertBefore(marker, items[0]);
      sorted.forEach(function (item) { parent.insertBefore(item, marker); });
      parent.removeChild(marker);
    });
  }

  function attach() {
    document.querySelectorAll('.search-results-panel').forEach(function (panel) {
      if (panel.dataset.rncSearchOrderBound) return;
      panel.dataset.rncSearchOrderBound = 'true';
      var updating = false;
      function run() {
        if (updating) return;
        updating = true;
        try { orderPanel(panel); } finally { updating = false; }
      }
      new MutationObserver(run).observe(panel, { childList: true, subtree: true });
      run();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
  document.addEventListener('focusin', function (event) {
    if (event.target.matches && event.target.matches('.is-predictive')) attach();
  });
})();